const isProd = process.env.NODE_ENV === "production";

let config = {
  prod: {
    url: "https://profit.mocca-ia.cl/api",
    files: "https://profit.mocca-ia.cl/api/files",
  },
  dev: {
    url: "http://localhost:8301/api",
    files: "http://localhost:8301/files",
  },
};

export default config[isProd ? "prod" : "dev"];
